/**
 * Way-of-stretch glyphs.
 *
 * Every figure is ridden along a path on the hall floor, and the abbreviation
 * in the figure name says which path. Drawing that path makes the shape of a
 * programme readable without decoding "HC." or "s.r." first.
 */
const PATHS: Readonly<Record<string, string>> = {
  'HC.': 'M3 13 A7 7 0 0 1 17 13',
  'C.': 'M10 3 A7 7 0 1 1 9.9 3',
  S: 'M4 14 A5 5 0 1 1 10 9 A5 5 0 1 0 16 4',
  '8': 'M10 9 A4.5 4.5 0 1 1 10 8.9 M10 9 A4.5 4.5 0 1 0 10 9.1',
  's.r.': 'M6.5 9 A4 4 0 1 1 6.4 9 M13.5 9 A4 4 0 1 1 13.4 9',
  'a.r.': 'M6.5 9 A4 4 0 1 1 6.4 9 M13.5 9 A4 4 0 1 0 13.4 9',
  'count. C': 'M10 3 A7 7 0 1 0 9.9 3',
  'count. 8': 'M10 9 A4.5 4.5 0 1 0 10 8.9 M10 9 A4.5 4.5 0 1 1 10 9.1',
};

function keyFor(wos: string): string | null {
  if (wos in PATHS) return wos;
  if (wos.startsWith('s.r.')) return 's.r.';
  if (wos.startsWith('count.')) return 'count. C';
  return null;
}

/** Returns safe HTML — the label is escaped, the path comes from the table. */
export function wosGlyph(wos: string | undefined): string {
  if (!wos) return '';
  const label = wos.replace(/[&<>"']/g, '');
  const key = keyFor(wos);
  if (key === null) return `<span class="wos"><span class="wos-label">${label}</span></span>`;
  return (
    `<span class="wos" title="${label}">` +
    `<svg width="20" height="18" viewBox="0 0 20 18" aria-hidden="true">` +
    `<path d="${PATHS[key]}" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>` +
    `</svg><span class="wos-label">${label}</span></span>`
  );
}
